<template>
<div class="chapter">
<div class="inner_page">
<p class="h1a">IN CROSSING</p>
<p class="h1b">Commemorative Poem by Katy Whittingham</p>
<p class="h1c">1814–2014</p>
<p class="center"><i>As far from time—as History</i></p>
<p class="center"><i>As near yourself—as Today</i></p>
<p class="center"><i>—Emily Dickinson</i></p>
<p class="noindent1">Over the highest spar, can you picture a community?</p>
<p class="noindent">Sketch and shade with predetermined destiny</p>
<p class="noindent">and neatly settled susceptibility?</p>
<p class="noindent">In its age of arranged marriage between land and water,</p>
<p class="noindent">orphaned islands, crooked rivers,</p>
<p class="noindent">high harvests: cotton, rods, nails, bread,</p>
<p class="noindent">can you still hear the tall sea tale</p>
<p class="noindent">as it once washed over the weary waterman</p>
<p class="noindent">in decidedly neutral beds?</p>
<p class="noindent">Stop, and listen to the expectant hum</p>
<p class="noindent">before orders, before eighteen guns, before</p>
<p class="noindent">a simple sound could sunder, and not so simple men</p>
<p class="noindent">might propose a peaceful end—</p>
<p class="noindent">There are not always words that can capture, but when</p>
<p class="noindent">they do they can be too powerfully accurate,</p>
<p class="noindent">as brazen and blazing as that infamous red glare,</p>
<p class="noindent">urgent as surge winds and heavily burdened like iron rails—</p>
<p class="noindent">what choice did twelve Fearing men have</p>
<p class="noindent">but to stand for all of the others, among them,</p>
<p class="noindent">Cape cousins: Fancy, Nancy, and Elizabeth.</p>
<p class="noindent">Yet, chance is chance, and fortitude</p>
<p class="noindent">matches with what sea souls might expect.</p>
<p class="noindent">As an elephant will run from a bee,</p>
<p class="noindent">the mightier many set off on their watercourse</p>
<p class="noindent">with deserted vow to come back.</p>
<p class="noindent">But with waters crossed, history did change,</p>
<p class="noindent">once marched streets now call out names,</p>
<p class="noindent">and the earlier picture—a little tired in form,</p>
<p class="noindent">yet finely grained with preserved intent,</p>
<p class="noindent">may be mounted in the celebratory frame,</p>
<p class="noindent">in honor of the value secured,</p>
<p class="noindent">positioned at the arch of our inviting gateway.</p>
<p class="noindent2"><i>Wareham resident K<span class="small">ATY</span> W<span class="small">HITTINGHAM</span> is a poet and educator. Her book of poems</i>, By a Different Ocean, <i>was published by Plan B Press in Virginia in 2009. She teaches English at the University of Massachusetts–Dartmouth and Bridgewater State University</i>.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// crossing.vue?288abfe4